import Phaser from "phaser";

export default class Preload extends Phaser.Scene {
    constructor() {
        super({
            key: 'PreloadScene', 
            pack: {
                files: [
                    {
                        type: 'image', key: 'caws-image', url: '/assets/images/caws-image.png'
                    }
                ]
            }
        })
        
    }

    preload() {
        const cawsImage = this.add.image(0, 0, 'caws-image').setOrigin(0, 0)

        const progressBar = this.add.graphics()
        const progressBox = this.add.graphics()

        progressBox.fillStyle(0x222222, 0.8)
        progressBox.fillRect(
                this.cameras.main.width / 2 - 520 / 2, 
                this.cameras.main.height / 2 - 50 / 2,
                520, 50
        )
        this.load.on('progress', (value) => {
            progressBar.clear()
            progressBar.fillStyle(0xffffff, 1)
            progressBar.fillRect(
                this.cameras.main.width / 2  - 500 / 2,
                this.cameras.main.height / 2  - 30 / 2,
                500 * value,
                30
            )
        })

        const loadingText = this.add.text(this.cameras.main.width / 2, this.cameras.main.height / 2 - 60, 'Loading...', {
            fontSize: '32px',
            color: 'white',
            stroke: 'black',
        })
        loadingText.setOrigin(0.5, 0.5)

        this.load.once('complete', () => {
            progressBar.destroy()
            progressBox.destroy()
            loadingText.destroy()
            cawsImage.destroy()
            this.scene.start('GameScene')
        })

        

        
        this.load.spritesheet('environment-128-1-sheet', '/assets/tilesets/environment/128_1.png', {
            frameWidth: 128,
            frameHeight: 128,
            margin: 1,
            spacing: 2
        })
        this.load.spritesheet('environment-128-2-sheet', '/assets/tilesets/environment/128_2.png', {
            frameWidth: 128,
            frameHeight: 128,
            margin: 1,
            spacing: 2
        })
        this.load.spritesheet('environment-256-sheet', '/assets/tilesets/environment/256.png', {
            frameWidth: 128,
            frameHeight: 128,
            margin: 1,
            spacing: 2
        })
        this.load.spritesheet('environment-512-1-sheet', '/assets/tilesets/environment/512_1.png', {
            frameWidth: 128,
            frameHeight: 128,
            margin: 1,
            spacing: 2
        })
        this.load.spritesheet('environment-512-2-sheet', '/assets/tilesets/environment/512_2.png', {
            frameWidth: 128,
            frameHeight: 128,
            margin: 1,
            spacing: 2
        })
        this.load.spritesheet('environment-512-3-sheet', '/assets/tilesets/environment/512_3.png', {
            frameWidth: 128,
            frameHeight: 128,
            margin: 1,
            spacing: 2
        })
        this.load.spritesheet('environment-512-4-sheet', '/assets/tilesets/environment/512_4.png', {
            frameWidth: 128,
            frameHeight: 128,
            margin: 1,
            spacing: 2
        })

        this.load.spritesheet('cartoon-wasp-walk-sheet', '/assets/sprites/cartoon-wasp.png', {
            frameWidth: 168,
            frameHeight: 168
        })
        this.load.spritesheet('mosquito-walk-sheet', '/assets/sprites/mosquito.png', {
            frameWidth: 236,
            frameHeight: 235
        })

        
        this.load.spritesheet('trampoline-sheet', '/assets/tilesets/trampoline.png', {
            frameWidth: 128,
            frameHeight: 58,
            margin: 1,
            spacing: 2
        })
        this.load.spritesheet('basic-rat-walk-sheet', '/assets/sprites/rat-walk.png', {
            // frameWidth: 256,
            // frameHeight: 92
            frameWidth: 192,
            frameHeight: 70
        })
        this.load.spritesheet('white-rat-walk-sheet', '/assets/sprites/white-rat-walk.png', {
            // frameWidth: 256,
            // frameHeight: 92
            frameWidth: 192,
            frameHeight: 70
        })
        this.load.spritesheet('wasp-walk-sheet', '/assets/sprites/wasp-flying.png', {
            frameWidth: 155,
            frameHeight: 173
        })
        this.load.spritesheet('lava-walk-sheet', '/assets/sprites/lava-walk.png', {
            frameWidth: 149,
            frameHeight: 132
        })
        this.load.spritesheet('moving-platform-walk-sheet', '/assets/sprites/moving-platform.png', {
            frameWidth: 128,
            frameHeight: 32
        })

        this.load.spritesheet('flag', '/assets/sprites/flag.png', {
            frameWidth: 224,
            frameHeight: 266
        })
        this.load.spritesheet('cage', '/assets/sprites/cage.png', {
            frameWidth: 338,
            frameHeight: 338
        })

        this.loadLevelAssets()

        this.loadCollectables()

        this.load.image('back', '/assets/images/back.png')

        this.load.image('gameover', '/assets/images/gameover.png')
        this.load.image('victory', '/assets/images/victory.png')
        this.load.image('stagecleared', '/assets/images/stagecleared.png')

        this.load.audio('background', '/assets/sounds/background.mp3')
        this.load.audio('jump', '/assets/sounds/jump.mp3')
        this.load.audio('collect', '/assets/sounds/collect.mp3')
        this.load.audio('hit', '/assets/sounds/hit.mp3')
        this.load.audio('flagoverlap', '/assets/sounds/flagoverlap.mp3')
        this.load.audio('trampolinejump', '/assets/sounds/trampolinejump.mp3')
        this.load.audio('failing', '/assets/sounds/failing.mp3')
        this.load.audio('killenemy', '/assets/sounds/killenemy.mp3')
        this.load.audio('herodie', '/assets/sounds/herodie.mp3')

    }

    loadLevelAssets = () => {
        for (let i = 1; i <= 10; i++) {
            this.load.image(`background-${i}-01`, `/assets/images/backgrounds/background-${i}-1.png`)
            this.load.image(`background-${i}-02`, `/assets/images/backgrounds/background-${i}-2.png`)
            
            this.load.tilemapTiledJSON(`level-${i}`, `/assets/tilemaps/level-${i}.json`)
           
            this.load.spritesheet(`world-${i}-sheet`, `/assets/tilesets/platforms/${i}-e.png`, {
                frameWidth: 128,
                frameHeight: 128,
                margin: 1,
                spacing: 2,
            })

            this.load.spritesheet(`hero-${i}-sheet`, `/assets/hero/cat-${i}.png`, {
                frameWidth: 216,
                frameHeight: 216
            })
        }    
    }

    loadCollectables = () => {
        this.load.image('coin', '/assets/collectables/coin.png')
        this.load.image('life', '/assets/collectables/life.png')
        this.load.image('diamond', '/assets/collectables/diamond.png')
        this.load.image('chest', '/assets/collectables/chest.png')
        this.load.image('watch', '/assets/collectables/watch.png')
        this.load.image('star', '/assets/collectables/star.png')
    }
}